import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import { getContentLocale, getUiLocale } from '@@scripts/store/settings/useSettingsStore';

import { SOCCER_TEAM_TYPE } from '../-components/constants';
import { teamListQuery } from '../-components/teamListQuery';
import { teamListSearchParams } from '../-components/teamListSearchParams';
import { TeamTypeLayout } from '../-components/TeamTypeLayout';

export const Route = createFileRoute('/_authenticated/teams/soccerTeams')({
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => teamListSearchParams.parse(search),
    beforeLoad: ({ search }) => ({
        // Built on every load, so the options follow the languages as well as the search
        listQuery: teamListQuery(SOCCER_TEAM_TYPE, search, {
            contentLocale: getContentLocale(),
            uiLocale: getUiLocale(),
        }),
    }),
    loader: ({ context }) => {
        context.queryClient.infiniteQuery(context.listQuery).catch(doNothing());
    },
    component: () => <TeamTypeLayout team={SOCCER_TEAM_TYPE} />,
});
